import React from "react";

type PropsType = {
  style?: React.CSSProperties;
  size?: number;
};

const MikaSupportBot = ({ size = 100, style = {} }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
    >
      <g clip-path="url(#clip0_275_14334)">
        <path
          d="M12.3779 70.99L17.4541 63.0132"
          stroke="#003125"
          stroke-width="2.90067"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="42.7849"
          cy="42.7849"
          r="42.7849"
          transform="matrix(-1 0 0 1 96.4971 5)"
          fill="#5DF5C9"
        />
        <path
          d="M26.8711 83.9253L14.053 90.1776L10.9269 83.7686"
          stroke="#003125"
          stroke-width="2.90067"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="8.91352"
          cy="8.91352"
          r="8.91352"
          transform="matrix(-1 0 0 1 60.8438 33.5229)"
          fill="white"
        />
        <circle
          cx="8.91352"
          cy="8.91352"
          r="8.91352"
          transform="matrix(-1 0 0 1 32.3203 33.5229)"
          fill="white"
        />
        <circle
          cx="5.34811"
          cy="5.34811"
          r="5.34811"
          transform="matrix(-1 0 0 1 57.2773 39.8076)"
          fill="#003125"
        />
        <circle
          cx="5.34811"
          cy="5.34811"
          r="5.34811"
          transform="matrix(-1 0 0 1 28.7549 39.8076)"
          fill="#003125"
        />
        <path
          d="M12.3779 70.9897L23.2554 76.0659"
          stroke="#003125"
          stroke-width="2.90067"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.3981 85.5721C13.4757 84.3301 13.6817 81.4551 15.7614 80.4998L30.2681 73.8362C31.5349 73.2543 32.9689 73.148 34.3077 73.5369L53.4641 79.1004C55.9998 79.8368 56.3128 83.3026 53.9501 84.4815L32.7246 95.0717C31.8073 95.5294 30.7165 95.4689 29.8554 94.9126L15.3981 85.5721Z"
          fill="#D7D8DB"
        />
        <path
          d="M6.11181 67.4132C5.55108 66.1925 6.80797 64.9312 8.0306 65.4877L23.8586 72.6923C24.5501 73.0071 25.0905 73.5806 25.3636 74.2895L32.9251 93.916C33.428 95.2213 31.9739 96.4118 30.7935 95.6613L14.9795 85.6053C14.5081 85.3056 14.1333 84.876 13.9001 84.3684L6.11181 67.4132Z"
          fill="#F2F2F3"
        />
        <path
          d="M42.835 83.8105L53.404 81.9955L61.4568 74.0948"
          stroke="#003125"
          stroke-width="2.90067"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55.7842 87.8599L43.7987 95.5892L39.934 89.5965"
          stroke="#003125"
          stroke-width="2.90067"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="79.0935"
          cy="45.6091"
          r="5.80134"
          fill="#494B50"
          stroke="#1D2029"
          stroke-width="2.90067"
        />
        <path
          d="M79.0933 52.8608V64.4635H63.1396"
          stroke="#1D2029"
          stroke-width="2.90067"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="57.3379"
          y="61.5625"
          width="7.25168"
          height="5.80134"
          rx="1.45034"
          fill="#1D2029"
        />
      </g>
      <defs>
        <clipPath id="clip0_275_14334">
          <rect width="100" height="100" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MikaSupportBot;
